import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const CTA = () => {
  return (
    <section className="bg-[#1a1a1a] py-0 relative w-full overflow-hidden">
      {/* Full width container, no internal max-width blocking the expansion if we want true edge-to-edge, or max-w-screen */}
      <div className="w-full">
        <div className="w-full mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="w-full py-16"
            style={{
              background: `
                radial-gradient(ellipse 60% 90% at 100% 50%, #3b82f6 0%, #1d4ed8 22%, #1e3a8a 45%, #0f172a 70%, #070b18 100%),
                linear-gradient(to right, #060b18 0%, #0f172a 30%, #1e3a8a 60%, #1d4ed8 100%)
              `,
              backgroundBlendMode: 'screen',
            }}
          >
            <div className="container flex flex-col md:flex-row items-center justify-between">
              {/* Left side text content */}
              <div className="flex flex-col space-y-4 max-w-2xl text-left">
                <span className="text-white uppercase tracking-[0.2em] text-xs font-bold font-sans">
                  Ready to secure your future?
                </span>
                
                <h2 className="text-3xl md:text-5xl font-medium text-white tracking-tight font-sans">
                  Enhance your organization's security posture
                </h2>
                
                <p className="text-white/90 text-base md:text-lg leading-relaxed max-w-xl font-sans mt-2">
                  Our team of experts is ready to help you identify vulnerabilities and implement robust security solutions tailored to your specific needs.
                </p>
              </div>

              {/* Right side CTA Button */}
              <div className="mt-10 md:mt-0 flex-shrink-0">
                <Link
                  to="/contact"
                  className="group inline-flex items-center bg-white hover:bg-gray-100/90 text-[#1e40af] px-8 py-3.5 font-bold text-sm transition-all duration-300 rounded-[2px]"
                >
                  <span>Schedule a Consultation</span>
                  <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform duration-300" />
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CTA;